<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'paymentDetails',
    components: {
      baseEdit,
    },
  };
</script>
